import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";

/**
 * Non-dismissible warning shown when the session is about to expire due to
 * inactivity. The user may click "Stay signed in" to refresh the activity
 * timestamp; otherwise the session is signed out when the countdown hits 0.
 */
export function IdleTimeoutDialog({
  open,
  secondsRemaining,
  onStaySignedIn,
}: {
  open: boolean;
  secondsRemaining: number;
  onStaySignedIn: () => void;
}) {
  const mins = Math.floor(secondsRemaining / 60);
  const secs = secondsRemaining % 60;
  const display = mins > 0 ? `${mins}:${String(secs).padStart(2, "0")}` : `${secs}s`;

  return (
    <Dialog open={open}>
      <DialogContent
        className="sm:max-w-md [&>button]:hidden"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>You'll be signed out soon</DialogTitle>
          <DialogDescription>
            You've been inactive. To keep working, click below — otherwise you'll
            be signed out automatically in <span className="font-semibold text-maroon-700">{display}</span>.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" onClick={onStaySignedIn} className="w-full">
            Stay signed in
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
